import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faThLarge,
    faListUl,
    faCommentDots,
    faChartLine,
} from "@fortawesome/free-solid-svg-icons";

import CuadroRequerimientosEstadisticas from "./menus/estadisticas/CuadroRequerimientosEstadisticas";
import CuadroDeRequerimientosTableView from "./menus/tableView/CuadroDeRequerimientosTableView";

import CuadroRequerimientosListarAsignadosPendiente from "./menus/cuadroRequerimientosListarAsignadosPendientes/CuadroRequerimientosListarAsignadosPendiente";
import CuadroRequerimientosComentarios from "./menus/comentarios/CuadroRequerimientosComentarios";
import {useParams} from "react-router-dom";
import { useManagePostRequest } from "../../../hooks/useManagePostRequest/useManagePostRequest";
import { cuadroRequerimientosGetCuadroRequerimientosAPI } from "../../../consumers/backendApisUrls";


export default function MainPageCuadroRequerimientos() {
    const { id } = useParams();
    const [active, setActive] = useState("page1");
    const [hovered, setHovered] = useState(null);
    const [cuadroInfo, setCuadroInfo] = useState({Sede: "", Anio: null,});
    const [executeManagePost] = useManagePostRequest();

    useEffect(() => {
        const cargarCuadroInfo = async () => {
            const api = cuadroRequerimientosGetCuadroRequerimientosAPI();

            await executeManagePost(
                api,
                { IdCuadroSede: Number(id) },
                ({ data }) => {
                    setCuadroInfo({
                        Sede: data?.Sede ?? "",
                        Anio: data?.Anio ?? null,
                    });
                }
            );
        };

        cargarCuadroInfo();
    }, [id]);

    const menus = [
        {
            key: "page1",
            title: "Tablero",
            icon: faThLarge,
            component:  <CuadroDeRequerimientosTableView idCuadroSede={id} />,
        },
        {
            key: "page2",
            title: "Pendientes / Asignados",
            icon: faListUl,
            component: <CuadroRequerimientosListarAsignadosPendiente idCuadroSede={id} />,
        },
        {
            key: "page3",
            title: "Notas / Observaciones",
            icon: faCommentDots,
            component: <CuadroRequerimientosComentarios idCuadroSede={id} />,
        },
        {
            key: "page4",
            title: "Ratio",
            icon: faChartLine,
            component: <CuadroRequerimientosEstadisticas idCuadroSede={id} />,
        },
    ];

    const activeMenu = menus.find(m => m.key === active);

    return (
        <div style={styles.container}>
            <aside style={styles.sidebar}>
                {menus.map(menu => (
                    <div
                        key={menu.key}
                        onClick={() => setActive(menu.key)}
                        onMouseEnter={() => setHovered(menu.key)}
                        onMouseLeave={() => setHovered(null)}
                        style={{
                            ...styles.menuItem,
                            ...(active === menu.key ? styles.menuItemActive : {}),
                            ...(hovered === menu.key && active !== menu.key
                                ? styles.menuItemHover
                                : {}),
                        }}
                    >
                        <FontAwesomeIcon icon={menu.icon} />

                        {hovered === menu.key && (
                            <div style={styles.tooltip}>
                                {menu.title}
                            </div>
                        )}
                    </div>
                ))}

            </aside>

            <main style={styles.content}>
                <div style={styles.cuadroInfo}>
                    <span>
                        <strong>Sede: </strong>
                        {cuadroInfo.Sede || "-"}
                    </span>

                    <span>
                        <strong>Año: </strong>
                        {cuadroInfo.Anio || "-"}
                    </span>
                </div>

                {activeMenu.component}
            </main>
        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        height: "100vh",
        background: "#fff",
    },

    cuadroInfo: {
        display: "flex",
        alignItems: "center",
        gap: "24px",
        marginBottom: "12px",
    },

    sidebar: {
        width: "56px",
        borderRight: "1px solid #e5e7eb",
        padding: "8px 4px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "6px",
    },

    menuItem: {
        position: "relative",
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#374151",
        fontSize: "16px",
        transition: "background 0.15s ease, color 0.15s ease",
    },

    menuItemActive: {
        background: "#e8f0fe",
        color: "#1a73e8",
    },

    tooltip: {
        position: "absolute",
        left: "48px",
        top: "50%",
        transform: "translateY(-50%)",
        background: "#fff",
        color: "#111827",
        padding: "6px 12px",
        borderRadius: "999px",
        fontSize: "13px",
        fontWeight: "500",
        whiteSpace: "nowrap",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        zIndex: 10,
    },

    content: {
        flex: 1,
        padding: "24px",
        overflow: "auto",
    },



    menuItemHover: {
        background: "#f3f4f6",
    },


};

